import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import Drawer from '@mui/material/Drawer';
import ConfigureAlert from './ConfigureAlert';
import LaunchIcon from '@mui/icons-material/Launch';

function AlertDrawer(props) {

    const [drawerOpen, setDrawerOpen] = useState(false);


    return (
        <div>
            <Link className="drawer-link" onClick={() => setDrawerOpen(true)}>{props.link} <LaunchIcon fontSize='small' /></Link>
            <Drawer
                anchor={'top'}
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
            >
                <div style={{ padding: '20px' }}>
                    <center><b><Link onClick={() => setDrawerOpen(false)}>CLOSE</Link></b></center>
                    <br></br>

                    <ConfigureAlert mobileView={props.mobileView} onAlgoSelected={props.onAlgoSelected} role={props.role} alertId={props.alertId} planId={props.planId} />
                    <br></br>
                    <center><b><Link onClick={() => setDrawerOpen(false)}>CLOSE</Link></b></center>
                </div>
            </Drawer>
        </div>
    );
}

export default AlertDrawer;